import ReportModel from "./Report";
import PreliminaryReportModel from "./PreliminaryReport";
import UserModel from "./User";
import OrganizationModel from "./Organization";
import StatusModel from "./Status";

const models = {
  ReportModel,
  UserModel,
  OrganizationModel,
  PreliminaryReportModel,
  StatusModel
};

class ModelFactory {
  create(
    model: string,
    data: object | Array<any> = {},
    array: boolean = false
  ) {
    let objects = null;

    if (array && !Array.isArray(data)) {
      data = [data];
    }
    if (Array.isArray(data)) {
      objects = data.map(item => new (models as any)[model](item));
    } else {
      objects = new (models as any)[model](data);
    }

    return objects;
  }
}

const modelFactory = new ModelFactory();

export default modelFactory;
